module.exports = "<asui-breadcrumbs items=\"$ctrl.items\" on-item-click=\"$ctrl.onItemClick(item)\"></asui-breadcrumbs>";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/asBreadcrumb/asBreadcrumb.component.html
// module id = 659
// module chunks = 0